<template>
  <v-layout>
    <v-btn
      fixed
      round
      bottom
      right
      light
      color="grey"
      white
      outline
      style="bottom:12px;z-index:99999"
      :loading="isSelecting"
      @click="onAttachmentButtonClick"
    >
      <v-icon>attachment</v-icon>
    </v-btn>
    <v-layout row wrap>
      <v-list two-line style="width:100vw;max-width:100vw">
        <template v-for="(file, key) in getAttachments">
          <v-list-tile flat tile class="d-flex" :key="key">
            <v-list-tile-avatar
              tile
              :ref="'file' + parseInt(key)"
              color="blue"
              v-if="file.details.type == 'image'"
            >
              <img :src="file.src" :ref="'file' + parseInt(key)" />
            </v-list-tile-avatar>
            <v-list-tile-avatar
              tile
              :ref="'file' + parseInt(key)"
              :color="file.details.color"
              v-else
            >
              <v-icon>{{ file.details.icon }}</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-sub-title
                class="filename"
                v-html="file.name"
              ></v-list-tile-sub-title>
              <v-list-tile-sub-title v-html="file.size"></v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-btn icon ripple @click.stop="deleteAttachment(file)">
                <v-icon color="grey">clear</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
        </template>
      </v-list>
    </v-layout>
    <input
      ref="uploader"
      type="file"
      multiple="true"
      accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"
      @change="onFileChanged"
      class="d-none"
    />
  </v-layout>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'AttachmentsWrapper',
  mixins: [],
  components: {},
  data() {
    return {
      isSelecting: false,
      files: []
    }
  },
  mounted() {},
  computed: {
    ...mapGetters({
      getAttachments: 'webmail/getAttachments'
    })
  },
  methods: {
    ...mapActions({
      addAttachment: 'webmail/addAttachment',
      deleteAttachment: 'webmail/deleteAttachment'
    }),
    onAttachmentButtonClick() {
      this.isSelecting = true
      window.addEventListener(
        'focus',
        () => {
          this.isSelecting = false
        },
        { once: true }
      )

      this.$refs.uploader.click()
    },
    onFileChanged(e) {
      const selectedFiles = e.target.files
      for (var i = 0; i < selectedFiles.length; i++) {
        this.files.push(selectedFiles[i])
      }
      for (var x = 0; x < this.files.length; x++) {
        const reader = new FileReader()
        const ref = 'file' + x
        const that = this
        const fileName = this.files[x].name
        reader.addEventListener(
          'load',
          function() {
            const fileData = reader.result
            that.addAttachment({
              name: fileName,
              contentBytes: btoa(fileData),
              src: fileData,
              details: this.getFiletype(fileName)
            })
          }.bind(this),
          false
        )
        reader.readAsDataURL(this.files[x])
      }
      this.files = []
    },
    getFiletype(fileName) {
      const extension = fileName.split('.').pop()
      if (_.contains(['jpg', 'gif', 'png', 'jpeg'], extension)) {
        return { type: 'image', color: 'white', icon: '' }
      }
      if (extension == 'pdf') {
        return { type: 'pdf', color: 'red', icon: 'picture_as_pdf' }
      }
      if (_.contains(['doc', 'docx'], extension)) {
        return { type: 'word', color: 'blue', icon: 'book' }
      }
      if (_.contains(['xls', 'xlsx'], extension)) {
        return { type: 'excel', color: 'green', icon: 'grid_on' }
      }
      return { type: 'other', color: 'grey', icon: 'question' }
    }
  },
  watch: {}
}
</script>
<style scoped>
.filename {
  max-width: 60vw;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
